var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2008_16866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 7.58172 7.58172 4 12 4C13.2498 4 14.4558 4.34926 15.555 4.89551C16.0495 5.1413 16.6497 4.93961 16.8955 4.44503C17.1413 3.95045 16.9396 3.35027 16.445 3.10449C15.1343 2.45311 13.6239 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C13.6239 22 15.1343 21.5469 16.445 20.8955C16.9396 20.6497 17.1413 20.0495 16.8955 19.555C16.6497 19.0604 16.0495 18.8587 15.555 19.1045C14.4558 19.6507 13.2498 20 12 20C7.58172 20 4 16.4183 4 12Z",
    fill: "#97A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7071 7.29289C18.3166 6.90237 17.6834 6.90237 17.2929 7.29289C16.9024 7.68342 16.9024 8.31658 17.2929 8.70711L19.5858 11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H19.5858L17.2929 15.2929C16.9024 15.6834 16.9024 16.3166 17.2929 16.7071C17.6834 17.0976 18.3166 17.0976 18.7071 16.7071L22.7071 12.7071C23.0976 12.3166 23.0976 11.6834 22.7071 11.2929L18.7071 7.29289Z",
    fill: "#97A0A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2008_16866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.a10d9ab21d62a747a836b07da41436f1.svg";
export { ForwardRef as ReactComponent };